import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	border-radius: 6px;
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.gray[400]};
`;

export const Button = styled.button<{ $selected?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 30px;
	border: none;
	background-color: ${({ theme, $selected }) => ($selected ? theme.blue[600] : 'transparent')};
	color: ${({ theme, $selected }) => ($selected ? theme.gray[0] : theme.gray[700])};
	transition: background-color 0.15s ease;

	&:hover {
		background-color: ${({ theme, $selected }) =>
			$selected ? theme.blue[600] : theme.gray[200]};
	}
`;
